import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { ObjectPreviewPanelProps } from './types';

type EntryPointParams = {};

const objectPreviewPanelEntryPoint: EntryPoint<
	EntryPointComponent<{}, Record<string, never>, ObjectPreviewPanelProps, Record<string, never>>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/ObjectPreviewPanel" */ './index'
			).then((mod) => mod.ObjectPreviewPanel),
		{
			moduleId: 'object-preview-panel-entrypoint',
		},
	),
	getPreloadProps: ({}: EntryPointParams) => ({}),
});

export default objectPreviewPanelEntryPoint;
